// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //apiUrl: 'https://inside.ec-dev.kiongroup.net/rest/v2/',
  //apiUrl: 'https://inside.ec-uat.kiongroup.net/rest/v2/',
  apiUrl: 'https://localhost:9002/rest/v2/',
  // apiUrl: 'https://inside-dev.linde-mh.com/rest/v2/',
  clientId: 'pwa',
  clientSecret: 'secret',
  trusted: 'trusted',
  baseSite: 'dematicSite',
  basePath: '/en-us/',
  defaultLanguage: 'en',
  systemId: 'dev',
  idp: {
    //new -> clientId: '69ea2d1f-5a4b-4ac9-97b3-25071e41d89c',
    //new -> baseUrl: 'https://b2clindemhdev.b2clogin.com/B2CLindeMHDEV.onmicrosoft.com/',
    clientId: 'bcb67cb6-34d2-48d9-80a9-ddff304f9616',
    defaultAuthority: '',
    baseUrl: 'https://b2clindemhdev.b2clogin.com/B2CLindeMHDEV.onmicrosoft.com/',
    host: 'https://localhost:4200/auth',
    identity: {
      local: 'B2C_1A_LS_SIGNIN',
      resetPassword: 'B2C_1_lr_passwordreset_local'
    }
  },
  project: 'Dematic',
  gtmId: 'GTM-TP9GCWH',
  countryIsoCode: 'gb',
  defaultProductImage: 'https://howfix.net/wp-content/uploads/2018/02/sIaRmaFSMfrw8QJIBAa8mA-article.png',
  routes: {
    productBaseRoute: "p",
    productRoutes: {
      productId: ":productId",
      productComplete: ":productId/:productName"
    },
    sitesBaseRoute: 's',
    sitesRoutes: {
      siteId: ":siteId",
    },
    categoryBaseRoute: "c",
    checkoutBaseRoute: 'checkout',
    checkoutRoutes: {
      login:"login",
      register: "registration",
      address: "address",
      delivery: "delivery",
      payment: "payment",
      summary: "summary",
      confirmation: "confirmation"
    },
    authBaseRoute: 'auth',
	authGlobalRoute: 'auth/global',
	startPunchoutRoute: 'start/punchout',
    privacyPolicyBaseRoute: "privacy-policy",
    legalNoticeBaseRoute: "imprint",
    termsBaseRoute: "terms-and-conditions",
    basketBaseRoute: "basket",
    notfoundBaseRoute: "404",
    previewBaseRoute: "cx-preview",
    registerBaseRoute: "registration",
    faqBaseRoute: "faq",
	redirectBaseRoute: "payment/back",
    cookieHintRoute: "cookie-policy",
	welcomePageRoute: "welcome",
    faqRoutes: {
      contactRoute: "contact",
      confirmRoute: "confirmation"
    },
    ordertrackingRoutes: {
      details : "ordertracking-details",
      list : "ordertracking"
    },
    registerationRequestBaseRoute: "registration-request",
    searchBaseRoute: "search",
    requestBasket: "request-basket",
    quickorderBaseRoute: "quick-order",
    sparepartRoutes: {
		overview:"spare-parts",
		search: "spare-parts/unit/:unitId",
		searchMat: "spare-parts/material/:materialNumber"
	},
    savedCartsRoute: "saved-carts",
	salesForceRoute: "sales-force"
  },
  kommunicateAppId: "3375a2d5147b738d50931502a6774747e"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
